import {TagCloseButton, TagLabel} from '@chakra-ui/react';
import type {GroupBase, MultiValueProps} from 'chakra-react-select';

import {Tag} from '../../Tag';

export const MultiValue = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  children,
  innerProps,
}: MultiValueProps<Option, IsMulti, Group>) => {
  return (
    <Tag variant={`secondary`} size={`sm`} {...innerProps}>
      <TagLabel>{children}</TagLabel>
      <TagCloseButton />
    </Tag>
  );
};
